import dayjs from 'dayjs';
import 'dayjs/locale/pt-br';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import weekday from 'dayjs/plugin/weekday';

dayjs.extend(weekday);
dayjs.extend(utc);
dayjs.extend(timezone);

dayjs.locale('pt-br');

class DateHelper {
  static dateDiff(date: Date, reference: Date): number {
    return dayjs(DateHelper.getDateBRTimezone(date)).diff(DateHelper.getDateBRTimezone(reference), 'days');
  }

  static formatDate(date: string | Date, format = 'DD/MM/YYYY'): string {
    return dayjs(date).format(format);
  }

  static getDateBRTimezone(date?: string | Date): Date {
    return dayjs(date).tz('America/Sao_Paulo').toDate();
  }

  static subDays(date: string | Date, days: number): Date {
    return dayjs(DateHelper.getDateBRTimezone(date)).subtract(days, 'days').toDate();
  }

  static addDays(date: string | Date, days: number): Date {
    return dayjs(DateHelper.getDateBRTimezone(date)).add(days, 'days').toDate();
  }

  static dateIsEquals(date1: string | Date, date2: string | Date): boolean {
    return DateHelper.formatDate(date1, 'YYYY-MM-DD') === DateHelper.formatDate(date2, 'YYYY-MM-DD');
  }

  static dateBetween(date: string | Date, startDate: string | Date, endDate: string | Date): boolean {
    const dateTime = DateHelper.getDateBRTimezone(date).getTime();
    const startDateTime = DateHelper.getDateBRTimezone(startDate).setUTCHours(0, 0, 0, 0);
    const endDateTime = DateHelper.getDateBRTimezone(endDate).setUTCHours(23, 59, 59, 999);
    return dateTime >= startDateTime && dateTime <= endDateTime;
  }

  static lastDayOfMonth(yearMonth: string): number {
    return dayjs(DateHelper.getDateBRTimezone(`${yearMonth}-01`))
      .endOf('month')
      .toDate()
      .getDate();
  }

  static addMonth(date: string | Date, months: number): Date {
    return dayjs(DateHelper.getDateBRTimezone(date)).add(months, 'month').toDate();
  }

  static subMonth(date: string | Date, months: number): Date {
    return dayjs(DateHelper.getDateBRTimezone(date)).subtract(months, 'month').toDate();
  }

  static getRangeBetweenDates(startDate: string | Date, endDate: string | Date): string[] {
    const range: string[] = [];
    let currentDate = dayjs(DateHelper.getDateBRTimezone(startDate)).startOf('day');
    const end = dayjs(DateHelper.getDateBRTimezone(endDate)).startOf('day');

    while (currentDate.isBefore(end) || currentDate.isSame(end)) {
      range.push(currentDate.format('YYYY-MM-DD'));
      currentDate = currentDate.add(1, 'day');
    }

    return range;
  }
}

export { DateHelper };
